import {
  EnvironmentProviders,
  ErrorHandler,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { Router } from '@angular/router';

import * as Sentry from '@sentry/angular';

import { initKtSentry } from './init-kt-sentry';
import type { KtSentryConfig } from './kt-sentry-config';

/**
 *
 * @returns The result of this operation.
 * @param config The Config value.
 */
export function provideKtSentry(config: KtSentryConfig): EnvironmentProviders {
  const tracingEnabled = config.tracesSampleRate !== undefined;

  return makeEnvironmentProviders([
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    ...(tracingEnabled
      ? [
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          provideAppInitializer(() => {
            inject(Sentry.TraceService);
          }),
        ]
      : []),
    provideAppInitializer(() => {
      initKtSentry(config);
    }),
  ]);
}
